// extracted by mini-css-extract-plugin
export default {"card":"mY-z","carouselContainer":"nY-z","carouselContent":"oY-z"};